import { isTicketCanceled, TicketStatusEnum } from "../../components/reservations/res.enum";
import { IReservationRefund } from "../../interfaces/reservations/Cancellation.types";
import { IReservationV2 } from "../../interfaces/reservations/Reservations.types";
import { refundGraceState } from "./refundGrace";

type ReconfirmFacts = Pick<
  IReservationV2,
  | "paymentStatus"
  | "oneWayTicketDetails"
  | "roundWayTicketDetails"
  | "refunds"
  | "hasOpenDispute"
>;

// Whether "Rikonfirmo rezervimin" can apply: something was cancelled, no dispute is open, and
// the latest refund has neither reached the processor nor passed its hold, nor returned Gjirafa
// Money (that makes it final). The server re-checks everything (seats, operator, eSIM) and
// answers with a code.
export const canOfferReconfirm = (b: ReconfirmFacts, now: number = Date.now()): boolean => {
  if (b.hasOpenDispute) return false;
  if (b.paymentStatus === TicketStatusEnum.Refund || b.paymentStatus === TicketStatusEnum.Pending)
    return false;
  const tickets = [...(b.oneWayTicketDetails ?? []), ...(b.roundWayTicketDetails ?? [])];
  const cancelled =
    b.paymentStatus === TicketStatusEnum.Canceled || tickets.some((t) => isTicketCanceled(t.statusId));
  if (!cancelled) return false;
  const latest = (b.refunds ?? []).reduce<IReservationRefund | null>(
    (acc, r) => (!acc || r.id > acc.id ? r : acc),
    null
  );
  // No refund row means nothing the server can undo: it answers reconfirm.nothing_to_undo.
  if (!latest || latest.processorStatus) return false;
  if ((latest.creditsReturned ?? 0) > 0 || (latest.isRefundInCredits && latest.amount > 0)) return false;
  return refundGraceState(latest, now) !== "elapsed";
};
